import { Button, ButtonBorderRadius, ButtonTheme } from '@apply/components';

interface SelectFilesButtonProps {
    /** Receives the wrapper, which FileUploader opens the file dialog from (its dialogTrigger). */
    triggerRef: (element: HTMLDivElement | null) => void;
}

/** "Select Files". The button itself does nothing: a click on it reaches the hidden FileUploader's dialogTrigger. */
export const SelectFilesButton = ({ triggerRef }: SelectFilesButtonProps) => {
    return (
        <div ref={triggerRef}>
            <Button
                id='fileDropZone_select'
                theme={ButtonTheme.Tertiary}
                borderRadius={ButtonBorderRadius.Small}
                height='36px'
            >
                Select Files
            </Button>
        </div>
    );
};
